/**
 * karmic-cart.js
 * Place in: assets/karmic-cart.js
 * Include via: {{ 'karmic-cart.js' | asset_url | script_tag }}
 *
 * Handles:
 *  - karmicAddToCart(btnEl, variantId)  — called from product card buttons
 *  - Dawn theme cart drawer integration (fetch cart + dispatch events)
 */

window.karmicAddToCart = async function (btnEl, variantId) {
  if (!variantId) return;

  const btn = btnEl;
  const originalHTML = btn.innerHTML;

  // Loading state
  btn.classList.add('is-loading');
  btn.innerHTML = `
    <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
      fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
      stroke-linejoin="round" class="karmic-spin" aria-hidden="true">
      <path d="M21 12a9 9 0 1 1-6.219-8.56"/>
    </svg>
    Adding…`;
  btn.disabled = true;

  try {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    });

    if (!res.ok) throw new Error('Cart add failed');

    const cartItem = await res.json();

    // Success state
    btn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24"
        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
        stroke-linejoin="round" aria-hidden="true">
        <polyline points="20 6 9 17 4 12"/>
      </svg>
      Added!`;

    // Notify Dawn theme cart drawer / cart bubble
    document.dispatchEvent(new CustomEvent('karmic:cart-updated', { detail: cartItem }));

    // Dawn's native cart update event
    fetch(window.Shopify.routes.root + 'cart.js')
      .then(r => r.json())
      .then(cart => {
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

        // Update Dawn cart count bubble (works with standard Dawn selectors)
        const bubbles = document.querySelectorAll('.cart-count-bubble');
        bubbles.forEach(el => {
          const span = el.querySelector('span[aria-hidden]');
          if (span) span.textContent = cart.item_count;
          el.classList.remove('hidden');
        });

        // Open Dawn cart drawer if it exists
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer && typeof cartDrawer.open === 'function') {
          cartDrawer.open(btn);
        } else {
          // Fallback: try dispatching a custom event Dawn listens to
          const event = new CustomEvent('dispatch:cart-drawer:open', { bubbles: true });
          document.dispatchEvent(event);
        }
      });

    // Reset button after 2.5s
    setTimeout(() => {
      btn.innerHTML = originalHTML;
      btn.disabled = false;
      btn.classList.remove('is-loading');
    }, 2500);

  } catch (err) {
    console.error('[Karmic] Add to cart error:', err);
    btn.innerHTML = '⚠ Error — retry';
    btn.style.borderColor = '#c0392b';
    btn.style.color = '#c0392b';

    setTimeout(() => {
      btn.innerHTML = originalHTML;
      btn.disabled = false;
      btn.classList.remove('is-loading');
      btn.style.borderColor = '';
      btn.style.color = '';
    }, 2500);
  }
};

/* Spinner animation injected once */
(function () {
  if (document.getElementById('karmic-spin-style')) return;
  const style = document.createElement('style');
  style.id = 'karmic-spin-style';
  style.textContent = `
    @keyframes karmic-rotate {
      to { transform: rotate(360deg); }
    }
    .karmic-spin {
      animation: karmic-rotate 0.75s linear infinite;
      transform-origin: center;
    }
  `;
  document.head.appendChild(style);
})();
